import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    empty: "Escribe tu correo para suscribirte.",
    invalid: "Revisa tu correo: debe tener el formato nombre@correo.com.",
  },
  en: {
    empty: "Enter your email to subscribe.",
    invalid: "Check your email: it should look like name@email.com.",
  },
});
